import { createSlice } from '@reduxjs/toolkit'
import LocalDataStore from "../../common/LocalDataStore";
import CartModel from "./CartModel";
const initialState: CartModel = {
    products: [],
    totalPrice: 0,
    totalVat: 0,
    totalNet: 0,
    totalProducts: 0,
    useRitmitos: false,
    ritmitosAvailable: 0,
    ritmitosInOrders: 0,
    addressId: 0,
    transport: { active: false, freePriceGreaterThan: 0, prices: [] },
    transportPrice: { active: false, price: 0, priceNet: 0, priceVat: 0 }
}

function calculatePrices(cart: CartModel)
{
    cart.totalNet = 0
    cart.totalVat = 0
    cart.totalPrice = 0
    cart.totalProducts = 0
    let totalRitmitos = cart.ritmitosAvailable - cart.ritmitosInOrders;
    for (let x = 0; x < cart.products.length; x++) {
        let price = cart.products[x].product.price * cart.products[x].quantity
        let priceVat = cart.products[x].product.priceVat * cart.products[x].quantity
        for (let p = 0; p < cart.products[x].preferences.length; p++) {
            price += cart.products[x].preferences[p].price * cart.products[x].quantity
            priceVat += (cart.products[x].preferences[p].price - cart.products[x].preferences[p].priceNet) * cart.products[x].quantity
        }
        if (cart.useRitmitos) {
            const priceTruncate = Math.trunc(price * 100);
            if (totalRitmitos >= priceTruncate) {
                totalRitmitos -= priceTruncate;
                cart.products[x].useRitmitos = true;
                cart.products[x].price = 0;
                cart.products[x].priceVat = 0;
                cart.products[x].priceNet = 0
            } else {
                cart.products[x].useRitmitos = false;
                cart.products[x].price = price;
                cart.products[x].priceVat = priceVat;
                cart.products[x].priceNet = (price - priceVat)
                cart.totalNet += (price - priceVat);
                cart.totalVat += priceVat;
                cart.totalPrice += price;
            }
        } else {
            cart.products[x].useRitmitos = false;
            cart.products[x].price = price;
            cart.products[x].priceVat = priceVat;
            cart.products[x].priceNet = (price - priceVat)
            cart.totalNet += (price - priceVat);
            cart.totalVat += priceVat;
            cart.totalPrice += price;
        }
        cart.totalProducts += cart.products[x].quantity
    }
    if (cart.transport && cart.transport.active) {
        if (cart.totalPrice >= cart.transport.conf.freePriceGreaterThan)
            cart.transportPrice = { active: true, price: 0, priceNet: 0, priceVat: 0 }
        else {
            if (cart.transport.conf && cart.transport.conf.prices.length > 0) {
                const tPrice = cart.transport.conf.prices[0]
                cart.transportPrice = { active: true, price: tPrice.price, priceNet: tPrice.priceNet, priceVat: tPrice.priceVat }
                cart.totalPrice += tPrice.price
                cart.totalNet += tPrice.priceNet
                cart.totalVat += tPrice.priceVat
            }
        }
    }
    LocalDataStore.cartSave(cart);
}

export const counterSlice = createSlice({
    name: 'carts',
    initialState,
    reducers: {
        reducerCartLoad: (state) =>
        {
            state =  LocalDataStore.cartGet()
        },
        reducerCartClear: (state) =>
        {
            state =  new CartModel()
        },
        reducerCartProductAdd: (state, action) =>
        {
            state.products.push(action.payload)
            calculatePrices(state)
        },
        reducerCartProductQuantityChange: (state, action) =>
        {
            calculatePrices(state)

            const pIndex = action.payload.index;
            const pValue = action.payload.value;
            const product = state.products[pIndex];
            if (pValue === 1) {
                product.quantity++
            }
            else {
                if (product.quantity === 1) {
                    state.products.splice(pIndex, 1)
                }
                else
                    product.quantity--
            }
            calculatePrices(state)
        },
        reducerCartRitmitoUpdate: (state, action) =>
        {
            state.useRitmitos = action.payload.useRitmitos
            state.ritmitosAvailable = action.payload.ritmitosAvailable
            calculatePrices(state)
        },
        reducerCartTransportUpdate: (state, action) =>
        {
            action.payload.active = true
            state.transport = action.payload
            calculatePrices(state)
        },
        reducerCartAddressUpdate: (state, action) =>
        {
            state.addressId = action.payload
            calculatePrices(state)
        },
    },
})

export const { reducerCartLoad, reducerCartClear, reducerCartProductAdd, reducerCartProductQuantityChange, reducerCartRitmitoUpdate
    ,reducerCartTransportUpdate,reducerCartAddressUpdate  } = counterSlice.actions
export default counterSlice.reducer

/*
const cartsReducer = (state = initialState, action: any) =>
{
    switch (action.type) {
        case CART_LOAD:
            const c = LocalDataStore.cartGet()
            return {
                ...state,
                ...c
            }
        case CART_CLEAR:
            const cartClear: CartModel = new CartModel()
            calculatePrices(cartClear)
            return cartClear
        case CART_PRODUCT_ADD:
            const cartAdd = { ...state }
            cartAdd.products.push(action.payload)
            calculatePrices(cartAdd)
            return cartAdd
        case CART_PRODUCT_QUANTITY_CHANGE:
            const pIndex = action.payload.index;
            const pValue = action.payload.value;
            const cartChange = { ...state }
            const product = cartChange.products[pIndex];
            if (pValue === 1) {
                product.quantity++
            }
            else {
                if (product.quantity === 1) {
                    cartChange.products.splice(pIndex, 1)
                }
                else
                    product.quantity--
            }
            calculatePrices(cartChange)
            return cartChange

        case CART_USE_RITMITOS_UPDATE:
            const cartUpdate = { ...state, ...action.payload }
            calculatePrices(cartUpdate)
            return cartUpdate
        case CART_ADDRESS_UPDATE:
            const cartAddress = { ...state, addressId: action.payload }
            calculatePrices(cartAddress)
            return cartAddress
        case CART_TRANSPORT_UPDATE:
            action.payload.active = true
            const cartTransport = { ...state, transport: action.payload }
            calculatePrices(cartTransport)
            return cartTransport
    }
    return state;
}
export default cartsReducer;
*/